// Recommendation order for experts, shared by onboarding step 3 and
// Discover's Recommended filter (28 Jul 2026): people whose category sits
// in the user's chosen areas lead, ranked by how many of their topics
// survive the user's topic switches, with a published-practices tiebreak.
import { AREAS } from "../../shared/areas.js";
import { TOPICS } from "../../shared/ontology.js";
import type { ExpertLite } from "./api.js";

const TOPIC_ID_BY_LABEL = new Map(TOPICS.map((t) => [t.label, t.id]));

export function catsForAreas(areaIds: Iterable<string>): Set<string> {
  const chosen = new Set(areaIds);
  return new Set(AREAS.filter(([id]) => chosen.has(id)).flatMap(([, , , cats]) => cats));
}

export function recommendScore(
  e: ExpertLite,
  cats: Set<string>,
  topicOn: (topicId: string) => boolean,
): number {
  const ecats = e.cats?.length ? e.cats : e.cat ? [e.cat] : [];
  const catBonus = ecats.some((c) => cats.has(c)) ? 100 : 0;
  const overlap = (e.topicLabels ?? []).filter((label) => {
    const id = TOPIC_ID_BY_LABEL.get(label);
    return id ? topicOn(id) : false;
  }).length;
  return catBonus + overlap * 2 + (e.cardCount > 0 ? 1 : 0);
}

export function recommendSort(
  experts: ExpertLite[],
  cats: Set<string>,
  topicOn: (topicId: string) => boolean,
): ExpertLite[] {
  return [...experts].sort(
    (a, b) => recommendScore(b, cats, topicOn) - recommendScore(a, cats, topicOn) || a.name.localeCompare(b.name),
  );
}
